import { IReturnStatement } from "@lib/returnStaticProps";
import { GetStaticPaths, GetStaticProps } from "next";
import { ParsedUrlQuery } from "querystring";

import AttackLibraryLayout from "@layouts/AttackLibraryLayout";
import { returnStaticProps } from "@lib/returnStaticProps";
import craft from "@pages/api/craft";
import QueryAttackLibraryIndex from "@queries/attack-library/QueryAttackLibraryIndex.graphql";

export const getStaticPaths: GetStaticPaths = async () => {
	const paths = [];

	console.log(`Generating /attack-library/page/2`);

	paths.push({
		params: { pageNumber: "2" },
	});

	return { paths, fallback: "blocking" };
};

interface Params extends ParsedUrlQuery {
	pageNumber: string;
}

export const getStaticProps: GetStaticProps<IReturnStatement, Params> = async ({
	params,
}) => {
	const pageNumber: number = parseInt(params.pageNumber, 10);

	// Hard code the page's uri
	const uri = `/attack-library/page/${pageNumber}`;

	const pageIndex = pageNumber > 0 ? pageNumber - 1 : pageNumber;
	const offset = pageIndex * 20;

	// Fetch the page's data
	const response = await craft(QueryAttackLibraryIndex, {
		limit: 20,
		offset: offset,
	});

	const {
		pageEntry,
		attacks,
		attackCount,
		attackVectors,
		attackGoals,
		attackTactics,
		attackImpersonatedParties,
		attackImpersonatedBrands,
		attackTypes,
		attackThemes,
		attackLanguage,
		attackAttachmentType,
		attackAiGenerated,
		primaryNavigation,
		primaryCallToActions,
		globalSet,
	} = response;

	// Return props if entry exists, otherwise check Retour for redirects or 404
	const returnResponse = await returnStaticProps(
		{
			navigation: {
				primaryNavigation,
				primaryCallToActions,
			},
			pageEntry,
			globalSet,
			attacks,
			attackVectors,
			attackGoals,
			attackTactics,
			attackImpersonatedParties,
			attackImpersonatedBrands,
			attackTypes,
			attackThemes,
			attackLanguage,
			attackAttachmentType,
			attackAiGenerated,
			pageCount: Math.ceil(attackCount / 20),
			pageNumber,
		},
		!pageEntry,
		uri
	);

	return returnResponse;
};

interface IProps {
	pageEntry: any;
	attacks: any[];
	attackVectors: any[];
	attackGoals: any[];
	attackTactics: any[];
	attackImpersonatedParties: any[];
	attackImpersonatedBrands: any[];
	attackTypes: any[];
	attackThemes: any[];
	attackLanguage: any[];
	attackAttachmentType: any[];
	attackAiGenerated: any[];
}

const Page = ({
	pageEntry,
	attacks,
	attackVectors,
	attackGoals,
	attackTactics,
	attackImpersonatedParties,
	attackImpersonatedBrands,
	attackTypes,
	attackThemes,
	attackLanguage,
	attackAttachmentType,
	attackAiGenerated,
}: IProps): JSX.Element => {
	return <></>;
};

Page.Layout = AttackLibraryLayout;

export default Page;
